import { computed } from 'vue';

import { getProductsPriceInfo } from '../lib';

export function usePriceBreakDown(
  bookingStore,
  products,
  ancillariesStore,
  seatMapPrice,
  seatMapOriginalPrice,
) {
  return computed(() => {
    const basePrice = Number(bookingStore.state?.ticketPrice || 0);
    const packageTitle = products.packageInfo.value.title;
    const packagePrice = Number(products.packageInfo.value?.price || 0);

    const productsPrice = Object.keys(products.state.value).reduce(
      (acc, productKey) =>
        (acc += getProductsPriceInfo(products.state.value[productKey])),
      0,
    );

    const selectedProducts = products.selectedProducts.value.map(product => ({
      ...product,
      price: {
        ...product.price,
        ...(products.state.value[product.service].data && {
          amount: products.state.value[product.service].data.amount
            ? getProductsPriceInfo(products.state.value[product.service])
            : product.price.amount,
        }),
      },
    }));

    const baggagePrice = ancillariesStore.passengersWithBaggage.data
      ?.hasSelectedBaggage
      ? Number(ancillariesStore.passengersWithBaggage.totalPrice)
      : null;
    const baggageOriginalPrice = ancillariesStore.passengersWithBaggage.data
      ?.hasSelectedBaggage
      ? Number(ancillariesStore.passengersWithBaggage.totalOriginalPrice)
      : null;

    const insurancePrice =
      bookingStore.medicalInsuranceProducts.length > 0
        ? bookingStore.medicalInsuranceProducts.reduce(
            (acc, product) => acc + (product.price || 0),
            0,
          )
        : null;

    const flightDelayPrice = bookingStore.flightDelayProducts?.length
      ? bookingStore.flightDelayProducts.reduce(
          (sum, p) => sum + (p.price || 0),
          0,
        )
      : null;

    const roamingPrice = products.isRoamingSelected.value ? 0 : null;

    const totalPrice =
      basePrice +
      Number(packagePrice) +
      Number(productsPrice) +
      Number(baggagePrice) +
      Number(seatMapPrice.value) +
      Number(insurancePrice) +
      Number(roamingPrice) +
      Number(flightDelayPrice);

    return {
      basePrice,
      packagePrice,
      packageTitle,
      productsPrice,
      baggagePrice,
      baggageOriginalPrice,
      seatMapPrice: seatMapPrice.value,
      seatMapOriginalPrice: seatMapOriginalPrice.value,
      roamingPrice,
      insurancePrice,
      totalPrice,
      selectedProducts,
      flightDelayPrice,
    };
  });
}
